(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookStatisticDeleteController',HandbookStatisticDeleteController);

    HandbookStatisticDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookStatistic'];

    function HandbookStatisticDeleteController($uibModalInstance, entity, HandbookStatistic) {
        var vm = this;

        vm.handbookStatistic = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookStatistic.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
